import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-4">
      <button className="w-full py-6 flex justify-between items-center text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-5">
        <span className="text-lg font-bold text-navy pr-4" data-id="element-6">{question}</span>
        <ChevronDownIcon className={`w-6 h-6 text-green transform transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-7" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-8">
        <p className="text-text-muted text-lg leading-relaxed" data-id="element-9">{answer}</p>
      </div>
    </div>;
}
export function FAQSection() {
  const faqs = [{
    question: '¿En qué formato se entrega el producto?',
    answer: 'Es un Ebook 100% digital en formato PDF. Podrás descargarlo inmediatamente después de tu compra y leerlo en tu celular, tablet o computadora.'
  }, {
    question: '¿Sirve si acabo de llegar a Estados Unidos?',
    answer: 'Sí, de hecho es el mejor momento para leerlo. Evitarás los errores comunes que cometen los recién llegados y empezarás a construir tu historial correctamente desde el día 1.'
  }, {
    question: '¿Cuánto tiempo tardaré en ver resultados?',
    answer: 'Si aplicas las estrategias del libro, empezarás a ver tu score reflejado en los burós de crédito en los primeros 30 a 45 días. El crecimiento sostenido a 700+ dependerá de tu constancia siguiendo el plan.'
  }, {
    question: '¿El pago es seguro?',
    answer: 'Totalmente. Procesamos los pagos a través de plataformas encriptadas de alta seguridad. Tu información financiera nunca es almacenada en nuestros servidores.'
  }];
  return <section className="bg-white py-20 px-4" data-id="element-10">
      <div className="max-w-3xl mx-auto" data-id="element-11">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-12 text-center" data-id="element-12">
          Preguntas Frecuentes
        </h2>

        <div className="bg-gray-light rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-13">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-14" />)}
        </div>
      </div>
    </section>;
}